<form
	#editForm="ngForm"
	[formReset]="editForm"
	(ngSubmit)="editForm.valid && submit()">
	<div class="modal-header">
		<h4 class="modal-title">{{'labels.' + title | translate}}</h4>
		<button
			type="button"
			class="close"
			aria-label="Close"
			(click)="dismiss()">
			<span aria-hidden="true">×</span>
		</button>
	</div>
	<div
		class="modal-body"
		ngbAutofocus>
		<div class="row">
			<div class="col-sm-12">
				<div class="form-group">
					<label>{{'labels.hours' | translate}}*</label>
					<input
						type="number"
						max="8"
						min="0"
						step="1"
						class="form-control"
						name="hours"
						[(ngModel)]="calendarDay.exception.hours"
						required
						#hours="ngModel"
						[ngClass]="{'is-invalid': editForm.submitted && hours.invalid}">
					<div
						class="invalid-feedback"
						*ngIf="editForm.submitted && hours.invalid">
						{{'errors.required' | translate}}
					</div>
				</div>
			</div>
			<div class="col-sm-12">
				<div class="form-group">
					<label>{{ 'labels.note' | translate }}</label>
					<textarea
						[(ngModel)]="calendarDay.exception.note"
						#note="ngModel"
						name="note"
						class="form-control"
						rows="5"
						required
						[ngClass]="{'is-invalid': editForm.submitted && note.invalid}">
					</textarea>
					<div
						class="invalid-feedback"
						*ngIf="editForm.submitted && note.invalid">
						{{'errors.required' | translate}}
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">

		<button
			type="reset"
			class="btn btn-secondary">
			{{'labels.reset' | translate}}
		</button>
		<button
			type="button"
			class="btn btn-secondary"
			(click)="dismiss()">
			{{'labels.cancel' | translate}}
		</button>
		<button
			type="submit"
			class="btn btn-primary">
			{{'labels.save' | translate}}
		</button>
	</div>
</form>
